/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Commit_Message_HelpInputs */

const en_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provide details about your changes to help team members understand what was modified.`)
};

const fr_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournissez des détails sur vos modifications pour aider les membres de l’équipe à comprendre ce qui a été modifié.`)
};

const de_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Details zu Ihren Änderungen an, damit die Teammitglieder verstehen, was geändert wurde.`)
};

const it_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornisci dettagli sulle modifiche per aiutare i membri del team a capire cosa è stato modificato.`)
};

const ru_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предоставьте подробную информацию об изменениях, чтобы члены команды могли понять, что именно было изменено.`)
};

const es_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporcione detalles sobre sus cambios para ayudar a los miembros del equipo a comprender qué se modificó.`)
};

const zh_cn2_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请详细说明您的更改，以便团队成员了解修改内容。`)
};

const ja_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム メンバーが何が変更されたかを理解できるように、変更に関する詳細を提供します。`)
};

const hi_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम के सदस्यों को यह समझने में मदद करने के लिए कि क्या संशोधित किया गया है, अपने द्वारा किए गए परिवर्तनों के बारे में विस्तृत जानकारी प्रदान करें।`)
};

const pt_pt2_team_sync_commit_message_help = /** @type {(inputs: Team_Sync_Commit_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forneça detalhes sobre as alterações para ajudar os membros da equipe a entender o que foi modificado.`)
};

/**
* | output |
* | --- |
* | "Provide details about your changes to help team members understand what was modified." |
*
* @param {Team_Sync_Commit_Message_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_commit_message_help = /** @type {((inputs?: Team_Sync_Commit_Message_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Commit_Message_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_commit_message_help(inputs)
	if (locale === "de") return de_team_sync_commit_message_help(inputs)
	if (locale === "it") return it_team_sync_commit_message_help(inputs)
	if (locale === "ru") return ru_team_sync_commit_message_help(inputs)
	if (locale === "es") return es_team_sync_commit_message_help(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_commit_message_help(inputs)
	if (locale === "ja") return ja_team_sync_commit_message_help(inputs)
	if (locale === "hi") return hi_team_sync_commit_message_help(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_commit_message_help(inputs)
	return en_team_sync_commit_message_help(inputs)
});